import React, {PureComponent} from 'react';
import {TrackingContext} from '@homeaway/react-event-tracking';
import {Link} from '@homeaway/react-localization-components';
import Details from './Details/Details';
import {Price} from './Price/Price';
import Rating from './Rating/Rating';
import {MULTIUNIT_ITEM_CLICK} from '../utils/edap';
import './MultiUnitItem.less';

export class MultiUnitItem extends PureComponent {
    static defaultProps = {
        starSize: 'sm'
    };
    static contextType = TrackingContext;

    renderMultiUnitItem = () => {
        const {
            bedrooms,
            sleeps,
            unitName,
            propertyType,
            bathrooms,
            spaces,
            averageRating,
            reviewCount,
            mobileThumbnailUrl,
            detailPageUrl,
            isMetric,
            isDatelessSearch,
            petsAllowed,
            starSize,
            context
        } = this.props;

        const detailsListing = {
            bathrooms,
            bedrooms,
            sleeps,
            propertyType,
            spaces,
            petsAllowed
        };

        const rateListing = {
            averageRating,
            reviewCount,
            starSize
        };

        return (
            <li className={`MultiUnitItem MultiUnitItem--${context}`}>
                <Link
                    className="MultiUnitItem__link"
                    href={detailPageUrl}
                    onClick={() => this.context.trigger(MULTIUNIT_ITEM_CLICK, this.props)}
                    target={'_blank'}
                >
                    <div className="MultiUnitItemImage">
                        <div
                            className="MultiUnitItemImage__image-div"
                            style={{
                                backgroundImage: `url(${mobileThumbnailUrl})`
                            }}
                        />
                    </div>
                    <div className="MultiUnitItem__content">
                        <div className="MultiUnitItem__content-row MultiUnitItem__content-row--title micro">
                            <strong className="MultiUnitItem__truncated-content">
                                {unitName || ' '}
                            </strong>
                        </div>
                        <div className="MultiUnitItem__content-row MultiUnitItem__content-row--details MultiUnitItem__truncated-content micro">
                            <Details
                                listing={detailsListing}
                                isMetric={isMetric}
                                propertyType={propertyType}
                            />
                        </div>
                        <div className="MultiUnitItem__content-row MultiUnitItem__content-row--price-ratings">
                            <Price listing={this.props} useAverageLabel={isDatelessSearch} />
                            <span className="Reviews">
                                <Rating listing={rateListing} />
                            </span>
                        </div>
                    </div>
                </Link>
            </li>
        );
    };

    render() {
        return this.renderMultiUnitItem();
    }
}
